import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { Archive, Inbox, SearchX } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type EmptyListResultsMode = 'search' | 'archived' | 'active';

const EMPTY_STATES_BY_MODE = {
  search: {
    title: 'Chat.SideBar.search.empty',
    icon: SearchX,
  },
  archived: {
    title: 'Chat.SideBar.archivedChats.empty',
    icon: Archive,
  },
  active: {
    title: 'Chat.SideBar.empty',
    icon: Inbox,
  },
};

export const EmptyListResults = ({ mode }: { mode: EmptyListResultsMode }): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.CHAT);
  const { title, icon: Icon } = EMPTY_STATES_BY_MODE[mode];
  return (
    <div className="flex flex-col items-center justify-center gap-4 py-10">
      <Icon className="size-10 text-gray-500" strokeWidth={1} />
      <p className="text-sm text-gray-500">{t(title)}</p>
    </div>
  );
};
